/* 공개(public-read) S3 객체 다운로드 — fetch→Blob 으로 강제 저장(파일명 지정·크로스오리진 안전).
   registry/code 버킷의 app/·firmware/·official/* 은 모두 public-read + CORS GET 허용이므로
   STS 자격 없이 익명 GET 으로 받는다. .py(text) 처럼 브라우저가 인라인 표시할 타입도
   Blob+download 로 일관되게 "다운로드"되게 한다.
   주의: 전체 바이트를 메모리에 적재하므로 매우 큰 파일은 부담(앱 설치파일 ~수십 MB 수준은 무난). */
export async function downloadObject(url, filename) {
  let res;
  try {
    res = await fetch(url, { cache: 'no-store' });
  } catch (e) {
    throw new Error('네트워크 또는 CORS 오류로 파일을 받지 못했습니다.');
  }
  if (!res.ok) {
    const err = new Error(res.status === 404 ? '파일을 찾을 수 없습니다 (404).' : `다운로드 실패 (HTTP ${res.status}).`);
    err.status = res.status;
    throw err;
  }
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = filename || (url.split('/').pop() || 'download');
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(objUrl), 1500);
}
